import { usePage } from '@inertiajs/react';
import React from 'react';
import { useSearch } from '../../hooks/useSearch';
import { useStatsCalculation } from '../../hooks/useStatsCalculation';
import { useStatusFilter } from '../../hooks/useStatusFilter';
import { useTreeFilter } from '../../hooks/useTreeFilter';
import { useTripUpdates } from '../../hooks/useTripUpdates';
import DriveSyncLayout from '../../layouts/DriveSyncLayout';
import TowerGrid from './TowerGrid';
import TowerHeader from './TowerHeader';

export default function Index() {
  const { props } = usePage();

  // Estado para controlar visibilidade dos cards
  const [showCards, setShowCards] = React.useState(true);

  // Usar hook para atualizações em tempo real
  const { trips, connectionStatus, lastUpdate, isRealTimeEnabled } = useTripUpdates(
    props.trips,
    props.selected_date
  );

  // Usar hook para filtros do tree view
  const {
    activeFilter,
    setActiveFilter,
    clearFilter,
    filteredItems: treeFilteredTrips,
    hasFilter,
    totalResults: treeFilteredCount,
    totalItems: originalTripsCount
  } = useTreeFilter(trips);

  // Usar hook para filtros por status (aplicado APÓS o filtro do tree view)
  const {
    selectedStatuses,
    filteredTrips: statusFilteredTrips,
    statusCounts,
    toggleStatus,
    clearStatusFilters,
    hasStatusFilters
  } = useStatusFilter(treeFilteredTrips);

  // Usar hook de pesquisa (aplicado APÓS os filtros anteriores)
  const {
    searchTerm,
    setSearchTerm,
    searchInputRef,
    filteredItems: finalFilteredTrips,
    hasSearch,
    totalResults: searchFilteredCount,
    totalItems: statusFilteredTripsCount
  } = useSearch(statusFilteredTrips, ['user_name', 'carrier_name']);

  // Calcular stats baseado nas trips filtradas finais
  const stats = useStatsCalculation(finalFilteredTrips);

  // Função para toggle dos cards
  const handleToggleCards = () => {
    setShowCards(!showCards);
  };

  // Função para limpar todos os filtros
  const handleClearAllFilters = () => {
    clearFilter();
    clearStatusFilters();
    setSearchTerm('');
  };

  return (
    <DriveSyncLayout>
      <TowerHeader
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        searchInputRef={searchInputRef}
        placeholder="Pesquisar..."
        totalResults={searchFilteredCount}
        totalTrips={originalTripsCount}
        hasSearch={hasSearch}
        activeFilter={activeFilter}
        hasFilter={hasFilter}
        onClearAllFilters={handleClearAllFilters}
        showCards={showCards}
        onToggleCards={handleToggleCards}
        // Status filter indicator props
        hasStatusFilters={hasStatusFilters}
        selectedStatuses={selectedStatuses}
      />
      <TowerGrid
        rows={finalFilteredTrips}
        stats={stats}
        isConnected={connectionStatus === 'connected'}
        lastUpdate={lastUpdate}
        connectionStatus={connectionStatus}
        isRealTimeEnabled={isRealTimeEnabled}
        selectedDate={props.selected_date}
        currentUser={props.current.user}
        searchTerm={searchTerm}
        activeFilter={activeFilter}
        onFilterChange={setActiveFilter}
        showCards={showCards}
        // Status filter props
        selectedStatuses={selectedStatuses}
        statusCounts={statusCounts}
        onToggleStatus={toggleStatus}
      />
    </DriveSyncLayout>
  );
} 